import request from "../../request.js"
import URL from "../../url/resetPassword/index.js"
class ResetPassword{
    //重置密碼
    static sendCode({email,captcha}){//發送驗證碼到郵箱
        return request.post({
            url: URL.EMAIL_CODE,
            data:{
                email,
                captcha
            },
            config: {
                // headers:{
                //     "Content-Type":"application/json"
                // },
                common: {
                    showFailMessage:true,
                    useToken: false
                }
            }
        })
    }
    static reset({account,password,token}){//忘記密碼-重置密碼
        return request.post({
            url: URL.RESET,
            data:{
                account,
                password,
                token
            },
            config: {
                headers:{
                    "Content-Type":"application/json"
                },
                common: {
                    showFailMessage:true,
                    useToken: false
                }
            }
        })
    }
    static centerReset({oldPassword1,password, confirmPassword}){//個人中心-重置密碼
        return request.put({
            url: URL.CENTER_RESET,
            data:{
                oldPassword1,
                password,
                confirmPassword
            },
            config: {
                headers:{
                    "Content-Type":"application/json"
                },
            }
        })
    }
}

export default ResetPassword